import React from 'react';
import { Input } from 'components/form/input';
import { SelectCurrency } from 'components/form/compobox/select-priceand-unit';
import CheckboxCustom from 'components/form/checkboxone';
import { useFormikContext } from 'formik';

// Ant Design Select
import { Select } from 'antd';

export default function PriceSectionHome({ idx }) {
  const { values, setFieldValue } = useFormikContext();

  // Seçenekler dizisi
  const cardTypeOptions = [
    'General Textile',
    'Special measures',
    'Adult apparel',
    'Kids apparel',
    'Object',
    'Stationery',
    'Basket',
    'Food contact',
    'Textile'
  ];

  return (
    <div className="space-y-2 border border-dashed p-2 rounded">
      {/* Başlıklar */}
      <div className="mb-2 grid grid-cols-2 gap-x-5 text-sm font-medium text-simsek">

      </div>

    
      <div className="mb-2" style={{display:"flex",justifyContent:"flex-start",alignItems:"center",marginBottom:20}}>
        <label style={{minWidth:100}} className="block text-sm font-medium text-simsek mb-1">
          Card Type
        </label>
        <Select
          id={`priceLabel[${idx}].cardType`}
          value={values.priceLabel[idx].cardType || undefined}
          placeholder="Seçiniz"
          allowClear
          onChange={(val) => setFieldValue(`priceLabel[${idx}].cardType`, val)}
          className="w-full h-10"
        >
          {cardTypeOptions.map((type) => (
            <Select.Option key={type} value={type}>
              {type}
            </Select.Option>
          ))}
        </Select>
      </div>
      {/* RFID checkbox */}
      <CheckboxCustom
        label="Siparişte RFID'li etiket var mı?"
        name={`priceLabel[${idx}].hasRFID`}
        idx={idx}
      />

      {/* AntD Select ile Card Type */}

    </div>
  );
}
